// extracted by mini-css-extract-plugin
export default {"tableWrapper":"tableStyles_tableWrapper__hamDq","table":"tableStyles_table__xLvhQ"};